var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.reload)?_c('TransactionTemplate',{ref:"supplier-payment",attrs:{"screenJson":_vm.getScreenJson,"setLoading":_vm.setLoading,"localDataGrid":_vm.baseView.mode != 'review',"backButtonRoute":_vm.backButtonRoute,"data-model":_vm.dataModel,"backRouteAppend":this.baseView.query && this.baseView.query.SUP_ID
      ? undefined
      : 'SupplierCode',"isLoaded":_vm.loaded,"validationSummary":_vm.validationSummary,"serverError":_vm.serverError,"getHeaderToolbar":_vm.getHeaderToolbar,"paging":false}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }